import React from 'react';
import styled from 'styled-components';

import { Button } from 'components';
import { FaBolt, FaArrowRight } from 'react-icons/fa';

const Container = styled.div`
    display: grid;
    grid-template-columns: 5rem min-content 5rem;
    height: 5rem;
    grid-column-gap: 1rem;
    justify-content: center;
    align-items: center;
`

const Icon = styled.div`
    background-color: ${props => props.backgroundColor || 'var(--primary-color)'};
    border-radius: 5px;
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`

const FlowHeader = props => {
    const {
        triggerIcon,
        actionIcon,
        backgroundColor
    } = props;
    let updatedBackgroundColor = Object.assign({}, { trigger: 'var(--primary-color)', action: 'var(--primary-color)' }, backgroundColor)
    return (
        <Container>
            <Icon backgroundColor={updatedBackgroundColor['trigger']}>{triggerIcon || <FaBolt style={{fontSize: '2rem'}}/>}</Icon>
            <FaArrowRight style={{fontSize: '1.5rem', color: 'var(--primary-accent-color)'}}/>
            <Icon backgroundColor={updatedBackgroundColor['action']}>{actionIcon || <FaBolt style={{fontSize: '2rem'}}/>}</Icon>
        </Container>
    )
}

export default FlowHeader;